import { loadApp, unLoadModule } from '@weareduet/core';

let app;

function ensureApp(root = document.body) {
	if (!app) {
		app = loadApp(name => import(`../behaviours/${name}.js`), root);
	}

	return app;
}

export function hydrateBehaviours(root = document.body) {
	const instance = ensureApp(root);
	instance.hydrate(root);

	return instance;
}

export function destroyModule(id) {
	unLoadModule(id);
}

export function destroyBehavioursWithin(root = document.body) {
	const instance = ensureApp();
	instance.destroyWithin(root);
}
